import React, { useState, createContext, ReactNode, useContext, useEffect, useCallback } from "react";
import { messaging } from "../firebase";
import { onMessage } from "firebase/messaging";

interface NotificationProps {
  from: string;
  collapseKey: string;
  messageId: string;
  notification: {
    title: string;
    body: string;
    image: string;
  };
  data: {
    url: string;
  };
};

interface NotificationContextData {
  loading: boolean;
  notification: NotificationProps[];
  deleteNotification: (messageId: string) => void;
  deleteAllNotification: () => void;
}

interface NotificationProviderProps {
  children: ReactNode;
}

const NotificationContext = createContext({} as NotificationContextData);

function NotificationProvider({ children }: NotificationProviderProps) {

  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState<NotificationProps[]>([]);



  useEffect(() => {

    async function getNotification() {
      const notificationInfo = localStorage.getItem('@omni:notification');

      let notificationData: NotificationProps[] = JSON.parse(notificationInfo || '[]');

      if (notificationData.length > 0) {

        setNotification(notificationData);
      } else {
        setNotification([]);
      }

      setLoading(false);
    }

    getNotification();
  }, []);

  onMessage(messaging, (payload: any) => {
    let notificationData: NotificationProps[] = []
    if (notification.length < 10) { // verifica se o array tem menos de 10 objetos
      notificationData = [...notification, payload] // adiciona o objeto
      setNotification(notificationData);
      localStorage.setItem('@omni:notification', JSON.stringify(notificationData));
    } else {

      notification.shift(); // remove o objeto mais antigo
      notificationData = [...notification, payload]
      setNotification(notificationData); // adiciona o objeto mais recente
      localStorage.setItem('@omni:notification', JSON.stringify(notificationData));
    }
  });

  const deleteNotification = useCallback((messageId: string) => {

    let removeNotification = notification.filter(item => {
      return (item.messageId !== messageId)
    });

    setNotification(removeNotification);

    localStorage.setItem('@omni:notification', JSON.stringify(removeNotification));

  }, [notification]);

  const deleteAllNotification = useCallback(() => {

    setNotification([]);

    localStorage.setItem('@omni:notification', JSON.stringify([]));

  }, []);

  return (
    <NotificationContext.Provider value={{
      loading,
      notification,
      deleteNotification,
      deleteAllNotification
    }}>
      {children}
    </NotificationContext.Provider>
  );
}

function useNotification() {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }

  return context;
}

export {
  NotificationProvider,
  useNotification
}